import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation} from "react-router-dom";
import Error404 from './app/containers/Error404';
import UIRenderer from './app/containers/UIRenderer'

function NoMatch() {
    let location = useLocation();
  
    return (
      <div>
          <Error404 message={'No route matches '+location.pathname}/>
      </div>
    );
  }

/*
 UI-renderer could be running in different environment:
   1. running in brownser alone (COTP). it gets its parameters from url. We need extract url match.
   2. running in iframe (AD). it gets its parameters from js global variables. prefer not modify history.
   3. running as part of the another web application (CP). it gets its parameters from js global variables. Do not modify history.
 */

class App extends Component {
  render() {
    // console.debug(`App render ${window.location.href}`);
    return (
      <React.Fragment>
        {/* if the global parameters object exists then return <UIRenderer/>   */}

        <Router basename={"/ui-flow"}>
          <Switch>
            {/* 
              * Route match is fuzzy by default. the :flowName placeholder means that the Route matches pretty much any path. for example
              * /ui-flow/abc would match and flowName is abc
              * /abc would match too and flowName is abc!
              * 
             */}
            <Route path="/:flowName" component={UIRenderer}/>
            <Route>
               <NoMatch/>
            </Route>
          </Switch>
        </Router>
      </React.Fragment>
    );
  }

  componentDidMount(){
  }
  componentDidUpdate(){
  }
  componentWillUnmount(){
  }


  componentDidCatch(error:any, errorInfo:any) 
  {
      console.log("error:", error, "errorInfo:", errorInfo);
  }

}

export default App;
